// extracted by mini-css-extract-plugin
export default {"isActive":"DesignNav_isActive__djVYf"};